






import Vue from 'vue';
import Article from '@/components/Article.vue'
import { ArticleState } from '@/types/article'
import { SettingsState } from '@/store/settings'
import { PROJECT_DISPLAY_NAME } from '@/constants';

export default Vue.extend({

  components: {
    Article,
  },

  computed: {
    article(): ArticleState {
      return this.$store.state.article;
    },

    articleLemma(): string {
      return this.article.title;
    },

    settings(): SettingsState {
      return this.$store.state.settings;
    },
  },

  mounted() {
    this.loadData();
  },

  beforeDestroy() {
    this.$store.commit('discardArticle');
  },

  watch: {
    $route() {
      this.loadData();
    },
  },

  methods: {
    loadData() {
      let pid = this.$route.params.pid;
      if (!pid) {
        // Old ID, of the form "LEMMA:PID"
        const oldId = this.$route.params.title;
        [, pid] = oldId.split(':');
      }
      if (this.article.pid !== pid)
        this.$store.dispatch('loadArticle', { pid });
    },
  },

});

